/**
 * IndexedDB для того, що не можна тримати в OPFS.
 *
 * Тут живуть дві речі, і обидві — ключі. Невитягуваний `CryptoKey`
 * пристрою ([ADR-0015]) взагалі не існує як байти, тож покласти його
 * в SQLite неможливо навіть теоретично. Запис акаунта лежить поруч
 * із тієї ж причини: він потрібен раніше, ніж піднімається база.
 *
 * Версія 2 додала сховище акаунта до наявного сховища ключів. Оновлення
 * враховує, що на пристрої вже може бути версія 1 із ключем усередині —
 * знищити її означало б знищити всі записи.
 *
 * Версія 3 додала чергу захоплення ([ADR-0011]). Вона тут не тому, що так
 * зручно, а тому, що інакше нікуди: щоб відкрити базу, потрібен ключ, якого
 * при замкненому застосунку немає. Ключі з автоінкрементом — черга розбирається
 * в тому порядку, в якому людина писала.
 */
const DB_NAME = "beresta-keys";
const VERSION = 3;

export const KEY_STORE = "keys";
export const ACCOUNT_STORE = "account";
export const CAPTURE_STORE = "capture";

export function openKeyDb(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, VERSION);
    request.onupgradeneeded = () => {
      const db = request.result;
      // `createObjectStore` кидає, якщо сховище вже є, тож перевірка
      // обовʼязкова: оновлення з версії 1 бачить `keys` наявним.
      if (!db.objectStoreNames.contains(KEY_STORE)) db.createObjectStore(KEY_STORE);
      if (!db.objectStoreNames.contains(ACCOUNT_STORE)) db.createObjectStore(ACCOUNT_STORE);
      if (!db.objectStoreNames.contains(CAPTURE_STORE)) {
        db.createObjectStore(CAPTURE_STORE, { autoIncrement: true });
      }
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error ?? new Error("IndexedDB не відкрилася"));
  });
}

export function idbRequest<T>(
  db: IDBDatabase,
  store: string,
  mode: IDBTransactionMode,
  run: (s: IDBObjectStore) => IDBRequest<T>,
): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    const tx = db.transaction(store, mode);
    const request = run(tx.objectStore(store));
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error ?? new Error("запит до IndexedDB не вдався"));
  });
}
